import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { LIVE_SUBSCRIPTION_TRANSLATION_KEY } from "../constants";
export default /*#__PURE__*/_defineProperty({}, LIVE_SUBSCRIPTION_TRANSLATION_KEY, {
  CONFIRMATION_DIALOG_SUCCESS_TITLE: 'Inscripción confirmada',
  CONFIRMATION_DIALOG_SUCCESS_DESCRIPTION: 'Te enviaremos un correo cuando la trasmisión este en vivo :)',
  CONFIRMATION_DIALOG_SUCCESS_DESCRIPTION_WITH_CALENDAR: 'Te enviaremos un correo cuando la trasmisión este en vivo, además te sugerimos que agregues el live en tu calendario :)',
  CONFIRMATION_DIALOG_ERROR_TITLE: '¡Ups! Ocurrió un error',
  CONFIRMATION_DIALOG_ERROR_DESCRIPTION: 'No pudimos realizar la suscripción :(',
  OK_BUTTON_LABEL: '¡Entendido!',
  CALENDAR_BUTTON_LABEL: 'Agregar a calendario',
  RETRY_BUTTON_LABEL: 'Volver a intentarlo'
});